module.exports = __webpack_public_path__ + "img/feature-gridbg.d381e872.png";